import { render, staticRenderFns } from "./TifNovedadesMapa.vue?vue&type=template&id=e91a703a"
import script from "./TifNovedadesMapa.vue?vue&type=script&lang=js"
export * from "./TifNovedadesMapa.vue?vue&type=script&lang=js"
import style0 from "./TifNovedadesMapa.vue?vue&type=style&index=0&id=e91a703a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports